import React from 'react';
import { CreditCardIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { offerRows } from '../data/content';
export function Pricing() {
  return <section className="w-full bg-cream px-5 py-24 sm:py-32" data-id="element-168" data-mp="2oho0a7hepan5">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-169" data-mp="2jjw77a50zihd">
        <div className="mx-auto max-w-[620px] text-center" data-id="element-170" data-mp="2jk5uur2lldjw">
          <Reveal data-id="element-171" data-mp="1vt9xzfjabs5s">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-muted" data-id="element-172" data-mp="1vutff9gog995">
              Kom i gang i dag
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-173" data-mp="25s7vv92loy1g">
            <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-174" data-mp="25t96xdjm9kj6">
              Få hele Håndboldklar nu
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.12} data-id="element-175" data-mp="3h638ob618upi">
          <div id="tilbud" className="mx-auto mt-14 w-full max-w-[560px] scroll-mt-24 overflow-hidden rounded-card border border-line border-t-2 border-t-navy bg-white shadow-lift" data-id="element-176" data-mp="3h9hczoy9bdzl">
            <p className="border-b border-line px-7 py-4 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-muted" data-id="element-177" data-mp="4t5k78y411wg">
              Håndboldklar — hele samlingen
            </p>

            <div className="px-7 py-8 sm:px-9" data-id="element-178" data-mp="9qe2ran677y8">
              <dl data-id="element-179" data-mp="eqa7jc3oz3eu">
                {offerRows.map(row => <div key={row.label} className="flex items-baseline justify-between gap-4 border-b border-line py-4" data-id="element-180" data-mp="3d97i9szie6v1">
                    <dt className="text-base text-ink" data-id="element-181" data-mp="3i5pgsb48x8yx">{row.label}</dt>
                    <dd className="shrink-0 font-display text-xl font-bold text-navy" data-id="element-182" data-mp="3n5kbkpr56ip9">
                      {row.value}
                    </dd>
                  </div>)}

                <div className="flex items-baseline justify-between gap-4 py-5" data-id="element-183" data-mp="2uhofnn9ecutj">
                  <dt className="font-display text-xl font-bold uppercase tracking-wide text-navy" data-id="element-184" data-mp="2zgrcikf83uqf">
                    Samlet værdi
                  </dt>
                  <dd className="shrink-0 font-display text-2xl font-bold text-muted line-through" data-id="element-185" data-mp="2reia4epouhq4">
                    1.339 kr.
                  </dd>
                </div>
              </dl>

              <div className="border-t border-line py-10 text-center" data-id="element-186" data-mp="318im90je0n8c">
                <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-muted" data-id="element-187" data-mp="2w83c0huejvul">
                  I dag
                </p>
                <p className="mt-4 font-display text-[86px] font-bold leading-[0.85] text-navy sm:text-[104px]" data-id="element-188" data-mp="23ixfaief6loj">
                  249 kr.
                </p>
                <p className="mt-5 text-base font-semibold text-green" data-id="element-189" data-mp="2ihrgsa2itgz8">
                  Du sparer 1.090 kr.
                </p>
              </div>

              <CtaButton label="Ja tak — giv mig Håndboldklar" target="checkout" data-id="element-190" data-mp="3tv3c1wk7sr9s" />

              <div className="mt-6 grid gap-3 border-t border-line pt-6 text-sm text-muted sm:grid-cols-2" data-id="element-191" data-mp="3tx6e5eyn6auv">
                <p className="flex items-center gap-2" data-id="element-192" data-mp="adlcrj2nvjj">
                  <CreditCardIcon className="h-4 w-4 shrink-0 text-navy" aria-hidden="true" data-id="element-193" data-mp="8sr730o6em7" />
                  Sikker betaling · MobilePay og kort
                </p>
                <p className="flex items-center gap-2" data-id="element-194" data-mp="3nfv3k8phy7ou">
                  <DownloadIcon className="h-4 w-4 shrink-0 text-navy" aria-hidden="true" data-id="element-195" data-mp="3nhfxpx7wfom6" />
                  Øjeblikkelig download
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}